import API from 'app/utils/apiClient';

const socialSignIn = (social, accessToken) =>
  API.post('/sign/providers/social/in/', {
    social,
    accessToken,
  });

const socialSignUp = (social, accessToken) =>
  API.post('/sign/providers/social/up/', {
    social,
    accessToken,
    nickname: Math.random().toString(36).substring(2, 9),
    birthday: '1995-01-02',
    gender: 'FEMALE',
  });

export default {
  socialSignIn,
  socialSignUp,
};



// WEBPACK FOOTER //
// ./src/app/apis/sign.js